/**
 * @desc 加油站锁卡状态修改
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.ResPetrolStationLockCardParams): Promise<BaseResponse<defs.ResultBean<number>>> {
  return fetch({
    url: config.API_HOST + '/base/resPetrolStation/resPetrolStationLockCard',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
